// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rX6hc","toggleWrap":"styles_toggleWrap__2wM0Y","content":"styles_content__29MKA","selectAreaCode":"styles_selectAreaCode__PPpSI"};